import en from './en.json'
import de from './de.json'
import pl from './pl.json'
import fr from './fr.json'
import nl from './nl.json'

export default {
  en: en.sim,
  de: de.sim,
  pl: pl.sim,
  fr: fr.sim,
  nl: nl.sim,
  default: 'en'
}